import { useLocalStorageStringState } from './useLocalStorageState';
import { singletonHook } from 'react-singleton-hook';

export const NOTIFICATION_CONFIGURATIONS = [
	{
		value: 'bottomRight',
		label: 'Bottom Right',
	},
	{
		value: 'bottomLeft',
		label: 'Bottom Left',
	},
	{
		value: 'topRight',
		label: 'Top Right',
	},
];

const useNotificationPlacementSetting = () =>
	useLocalStorageStringState(
		'notificationPlacement',
		NOTIFICATION_CONFIGURATIONS[0].value
	);

export default singletonHook(
	[undefined, undefined],
	useNotificationPlacementSetting
);
